import React, { useEffect, useState } from 'react'
import { getBlogList } from '../../../services/cmsPage.service';
import "./style.scss";


const Blog = () => {
    const [blogData, setBlogData] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getBlogList({});
                setBlogData(Array.isArray(response?.data) ? response?.data : []);
                setLoading(false);
            }
            catch (error: any) {
                console.error("Error fetching data:", error);
                setError(error?.message ?? "Failed to load content");
                setLoading(false);
            }
        };
        fetchData();
    }, []);


    return (
        <div>
            <>
                {/* ==================== BANNER ==================== */}
                <section className="banner-section">
                    <div className="container">
                        <div className="row ">
                            <div className="col-md-12 ">
                                <div className="main-heading d-flex justify-content-center align-items-center">
                                    <h1 className="hero-title">Blog</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* ==================== LOADING BELOW BANNER ==================== */}
                {loading ? (
                    <section className="py-5 bg-light">
                        <div className="container">
                            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "50vh" }}>
                                <div
                                    className="spinner-border text-primary"
                                    role="status"
                                    style={{ width: "3rem", height: "3rem" }}
                                >
                                    <span className="visually-hidden">Loading…</span>
                                </div>
                            </div>
                        </div>
                    </section>
                ) : error ? (
                    /* ==================== ERROR BELOW BANNER ==================== */
                    <section className="py-5 bg-light">
                        <div className="container">
                            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "50vh" }}>
                                <div className="alert alert-danger text-center p-4" style={{ maxWidth: "500px" }}>
                                    <h4>Oops! Something went wrong.</h4>
                                    <p>{error}</p>
                                </div>
                            </div>
                        </div>
                    </section>
                ) : (
                    <>
                        {/* ==================== BLOG SECTION ==================== */}
                        <section className="recent-blog-section">
                            <div className="container">

                                <h2
                                    className="text-center mb-5"
                                    style={{ fontWeight: 700, color: "#392e08" }}
                                >
                                    Recent Posts
                                </h2>

                                {/* ---- DYNAMIC CONTENT FROM API ---- */}
                                {blogData?.length > 0 ? (

                                    <div className="row g-4 justify-content-center">

                                        {blogData?.map((item: any) => (
                                            <div className="col-md-6 col-lg-4" key={item?.uuid}>
                                                <div className="blog-card h-100">

                                                    <div className="blog-card-img">
                                                        <img
                                                            src={item?.image}
                                                            alt="Blog Image"
                                                            width={400}
                                                            height={250}
                                                            className="w-100"
                                                        />
                                                    </div>

                                                    <div className="p-4">
                                                        <div className="blog-meta mb-2">
                                                            <span className="author-span">
                                                                <img src="/assets/img/user-icon.svg" alt="User Icon" />
                                                                By {item?.author_name}
                                                            </span>
                                                            <span>
                                                                <img src="/assets/img/calander-icon.svg" alt="Calander Icon" /> {' '}
                                                                {(() => {
                                                                    const date = new Date(item?.created_at);
                                                                    if (isNaN(date.getTime())) return 'Invalid Date';
                                                                    const day = date.getDate();
                                                                    const month = date.toLocaleString('en-US', { month: 'long' });
                                                                    const year = date.getFullYear();
                                                                    return `${month} ${day}, ${year}`;
                                                                })()}
                                                            </span>
                                                        </div>
                                                        <div className="blog-title">
                                                            {item?.title}
                                                        </div>

                                                        {/* Use Next.js Link */}
                                                        <a href={`/blog-details/${item?.uuid}`} className="blog-link">
                                                            Read More <img src="/assets/img/long-arrow-icon.svg" alt="Arrow" width={20} height={20} />
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <div className="align-items-center m-4">
                                        <p className="text-muted text-center m-4" >No content available.</p>
                                    </div>
                                )}

                            </div>
                        </section>
                    </>
                )}
            </>
        </div>
    )
}

export default Blog